import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";

type Props = {
  saved: boolean;
  onPress: () => void;
};

export default function LocationPinCard({ saved, onPress }: Props) {
  return (
    <View style={styles.card}>
      <View style={styles.left}>
        <Text style={styles.label}>Location Pin</Text>
        <Text style={styles.help}>
          Set your shop or office location pin using your current location.
        </Text>

        <View style={[styles.badge, saved ? styles.badgeSaved : styles.badgeEmpty]}>
          <Text style={[styles.badgeText, saved ? styles.badgeTextSaved : styles.badgeTextEmpty]}>
            {saved ? "Saved" : "Not set"}
          </Text>
        </View>
      </View>

      <Pressable style={styles.button} onPress={onPress}>
        <Text style={styles.buttonText}>{saved ? "Change Pin" : "Set Pin"}</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderWidth: 1,
    borderColor: "#E5E7EB",
    borderRadius: 14,
    padding: 14,
    gap: 12,
    backgroundColor: "#fff",
  },
  left: {
    gap: 8,
  },
  label: {
    fontSize: 15,
    fontWeight: "700",
    color: "#111827",
  },
  help: {
    fontSize: 13,
    lineHeight: 18,
    color: "#6B7280",
  },
  badge: {
    alignSelf: "flex-start",
    borderRadius: 999,
    paddingHorizontal: 10,
    paddingVertical: 5,
  },
  badgeSaved: {
    backgroundColor: "#DCFCE7",
  },
  badgeEmpty: {
    backgroundColor: "#F3F4F6",
  },
  badgeText: {
    fontSize: 12,
    fontWeight: "700",
  },
  badgeTextSaved: {
    color: "#166534",
  },
  badgeTextEmpty: {
    color: "#4B5563",
  },
  button: {
    alignSelf: "flex-start",
    backgroundColor: "#111827",
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 10,
  },
  buttonText: {
    color: "#fff",
    fontWeight: "700",
    fontSize: 13,
  },
});